export default __webpack_public_path__ + "static/media/guide02.a708486c.png";